import type { z } from "zod";

import type { FlightFormValuesSchema } from "@/features/flights/components/flights/validation";

import type {
  FindUserTravelersTravelers,
  FindCitiesCityWithAirports,
  FindCitiesAirport,
  FindCitiesCity,
} from "./codegen";
import { SortOrder } from "./enums";

export type TravellerAgeGroup = "ADT" | "CHD" | "INF";
export const allTravellerAgeGroups: TravellerAgeGroup[] = ["ADT", "CHD", "INF"];

export type Traveller = FindUserTravelersTravelers;

export type SearchScope = "flights" | "hotels" | "trips";

export type Airport = Pick<FindCitiesAirport, "id" | "name" | "code"> & {
  cityName: string;
  countryName: string;
  type: "AIRPORT";
};

export type City = Pick<
  FindCitiesCity,
  "id" | "name" | "code" | "countryName" | "countryCode"
> & {
  type: "CITY";
};

export type CityWithAirports = Pick<
  FindCitiesCityWithAirports,
  "id" | "name" | "code" | "countryName" | "countryCode"
> & {
  airports: Airport[];
  type: "CITY";
};

export type FlightFormLocation = Airport | City;

export type TFlightFormFieldValues = z.input<FlightFormValuesSchema>;
export type TFlightFormValues = z.infer<FlightFormValuesSchema>;

export type CustomerEligibilityOutput =
  | {
      isEligible: true;
      sessionId: string;
      minCountOfMonth: number;
      maxCountOfMonth: number;
    }
  | {
      isEligible: false;
      errorCode?: number;
    };

export type SortValue<T extends string> = {
  order: SortOrder;
  field: T;
};

export enum ValidationExceptionCode {
  CannotContainGivenPattern = "VALIDATION_VALUE_CANNOT_CONTAIN_GIVEN_PATTERN",
  IsDateString = "VALIDATION_VALUE_IS_DATE_STRING",
  MinimumLength = "VALIDATION_VALUE_MINIMUM_LENGTH",
  MustBeOneOf = "VALIDATION_VALUE_MUST_BE_ONE_OF",
}

export type ApiError = {
  code: string;
  data: {
    validationExceptionCode: ValidationExceptionCode;
    property: string;
    message: string;
  }[];
  message: string;
  status: string;
};

export type ServiceType = "air" | "hotel" | "trip";
export type SnackbarMessage = {
  type?: "success" | "error" | "warning" | "info";
  content: string;
};

export type TravellerUpdatedEventData = {
  travellerOldData: Traveller;
  travellerNewData: Traveller;
};

export type TravellerRemovedEventData = {
  travellerId: string;
};

export type TravellerDeselectedEventData = {
  travellerId: string;
};

export type OfferSelectedEventData = {
  offerType: ServiceType;
};
